import { useMutation, useQuery } from '@apollo/client';
import { useCallback, useMemo } from 'react';

import { FIND_USER_FOR_REQUEST_TOKEN, GET_CLIENT_LINK_TOKEN_FOR_REQUEST } from './access-token.queries';
import { IUser } from '../../../lib/types';

export const useGetClientLinkToken = () => {
  const [mutation, rest] = useMutation<{ getMagicLinkTokenForRequest: string | null }>(
    GET_CLIENT_LINK_TOKEN_FOR_REQUEST
  );

  const getClientLinkToken = useCallback(
    (requestId: string, userId: string) => mutation({ variables: { requestId, userId } }),
    [mutation]
  );

  return { getClientLinkToken, ...rest };
};

export const useTokenUser = (variables: { requestId: string; token: string }) => {
  const { data, loading, error, called, refetch, networkStatus, client, observable, previousData } = useQuery<{ findUserForRequestToken: IUser | null }>(FIND_USER_FOR_REQUEST_TOKEN, {
    fetchPolicy: 'no-cache',
    variables,
    skip: !variables.token || variables.token.trim() === ''
  });

  const tokenUser = useMemo(() => data?.findUserForRequestToken, [data?.findUserForRequestToken]);

  return useMemo(() => ({
    loading,
    error,
    called,
    refetch,
    networkStatus,
    client,
    observable,
    previousData,
    tokenUser
  }), [loading, error, called, refetch, networkStatus, client, observable, previousData, tokenUser]);
};
